import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { CircularAvatar } from "../commons";
import { formatDate } from "../../utils/commonFunctions";
import { UserProfileType } from "../../redux/auth/authTypes";
import "./TeamDetails.scss"

type AppProps = {
  data: UserProfileType[] | [];
  tableHeader: TableHeadersType[];
  handleShowUserDetails: (data: any) => void;
};
const TeamDirectoryTableData = ({
  data,
  tableHeader,
  handleShowUserDetails,
}: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?.user_id}>
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value === "name") {
                    return (
                      <td
                        style={{whiteSpace:"nowrap", width: "240px" }}
                        
                      >
                        <div
                          className="ml-2"
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "7px",
                          }}
                          onClick={() => handleShowUserDetails(itemData)}
                        >
                          <CircularAvatar
                            name={`${itemData?.name}`}
                            image={
                              itemData?.profile_pic &&
                              itemData?.profile_pic?.file_url
                            }
                          />
                          <div
                            style={{
                              textDecoration: "underline",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            {`${itemData?.name} `}
                          </div>
                          </div>
                      </td>
                    );
                  } else if (header?.value === "email") {
                    return (
                      <td style={{ whiteSpace: "nowrap" }}>
                        {itemData?.email?.length > 25 ? (
                          <>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view-filter-invoice">
                                  {itemData?.email}
                                </Tooltip>
                              }
                            >
                              <span>
                                {itemData?.email.toLowerCase()?.substr(0, 20) +
                                  (itemData?.email &&
                                  itemData?.email?.length > 20
                                    ? "..."
                                    : "")}
                              </span>
                            </OverlayTrigger>
                            <br></br>
                            <span
                              style={{ color: "#6e7491", fontSize: "12px" }}
                            >
                              {itemData?.mobile_number && itemData?.mobile_number}
                            </span>
                          </>
                        ) : (
                          <>
                            {itemData?.email}
                            <br></br>
                            <span
                              style={{ color: "#6e7491", fontSize: "12px" }}
                            >
                              {itemData?.mobile_number && itemData?.mobile_number}
                            </span>
                          </>
                        )}
                      </td>
                    );
                  } else if (header?.value === "employment_status") {
                    return (
                      <td style={{ maxWidth: "120px" }}>
                        {/* {itemData?.employment_status ? itemData?.employment_status : "NA"} */}
                        <div
                          className={
                            itemData?.employment_status === "Full time"
                              ? `status-complete`
                              : itemData?.employment_status ===
                                "Part time"
                              ? "status-incomplete"
                              : itemData?.employment_status === "Intern"
                              ? "status-approval-pending"
                              : itemData?.employment_status ===
                                "Probation"
                              ? "manufacturing-journal"
                              : itemData?.employment_status ===
                                "Articleship"
                              ? "status-other"
                              : ""
                          }
                          style={{
                            borderRadius: "16px",
                            width:'85%',
                            textAlign: itemData?.employment_status
                              ? "center"
                              : "center",
                            marginTop: "5px",
                          }}
                        >
                         {itemData?.employment_status ? itemData?.employment_status : "NA"}
                        </div>
                      </td>
                    );
                  } else if (header?.value === "job_title") {
                    return (
                      <>
                        <td style={{ fontSize: "14px", minWidth: "300px" }}>
                          {itemData?.job_title}
                          {!itemData?.job_title &&
                            !itemData?.department &&
                            "NA"}
                          <br></br>
                          <span style={{ color: "#6e7491", fontSize: "12px" }}>
                            {itemData?.department}
                          </span>
                        </td>
                      </>
                    );
                  } else if (header?.value === "skills") {
                    const skillList = itemData?.skills || [];
                    const maxVisible = 5; 
                    return(
                      <td style={{minWidth: "300px"}}>
                        {skillList?.length > 0 ? (
                          <>
                          <div style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "5px",
                          }}>
                            {skillList?.slice(0, maxVisible).map((skill:any, index:any) => (
                              <span key={index} className="skillBadge" style={{marginRight: "5px"}}>
                                {skill}
                                {index < skillList?.length - 1 && index < maxVisible - 1 ? "" : ""}
                              </span>
                            ))}
                            {skillList?.length > maxVisible && (
                              <span style={{color: "#262a44", fontSize: "14px", fontWeight: "500"}}>
                                {" "}
                                +{skillList?.length - maxVisible} more
                              </span>
                            )}
                          </div>
                          </>
                        ): (
                          <span>NA</span>
                        )}
                      </td>
                    )
                  } else if (header?.value === "branch_name") {
                    return (
                      <td style={{ minWidth: "130px" }}>
                        <div>{itemData?.branch? itemData?.branch:"NA" }</div>
                      </td>
                    );
                  } else if (header?.value === "joining_date") {
                    return (
                      <td style={{minWidth:'150px'}}>
                        {itemData?.joining_date
                          ? formatDate(itemData?.joining_date)
                          : "NA"}
                      </td>
                    );
                  } else {
                    return <td> NA </td>;
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default TeamDirectoryTableData;
